import { Controller } from "@hotwired/stimulus"

// Switches the session form between one-time and weekly scheduling.
// Hidden blocks get their inputs disabled so only the active mode submits.
export default class extends Controller {
  static targets = ["checkbox", "oneTime", "weekly"]

  connect() {
    this.toggle()
  }

  toggle() {
    const weekly = this.checkboxTarget.checked
    this.oneTimeTargets.forEach((block) => this.setBlock(block, !weekly))
    this.weeklyTargets.forEach((block) => this.setBlock(block, weekly))
  }

  setBlock(block, active) {
    // Inline style, not the hidden attribute: Tailwind display classes
    // (e.g. .grid) would override [hidden]'s display:none.
    block.style.display = active ? "" : "none"
    // querySelectorAll is intentional: day-grid rows are dynamic tags, not
    // Stimulus targets. Disable every control in the inactive mode block.
    block.querySelectorAll("input, select").forEach((field) => {
      field.disabled = !active
    })
  }
}
